import { uniq } from "lodash";
import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Card,
  Checkbox,
  CheckboxProps,
  Form,
  Header,
  Icon,
} from "semantic-ui-react";
import { ApplicationPermission } from "../models/ApplicationPermission";
import { FormError } from "../models/FormError";
import ErrorsView from "./ErrorsView";
import { useState } from "react";

export interface FormData {
  displayName: string;
  permissionNames: string[];
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  adminPermissions?: ApplicationPermission[];
}

const EditAdminRoleForm = ({ formData, formErrors, errors, onChange, adminPermissions }: Props) => {
  const [accordionActiveIndex, setAccordionActiveIndex] = useState(0);

  const handleChange = (e: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  const handlePermissionChange = (e: any, { checked, value: permissionName }: CheckboxProps) => {
    if (!permissionName) {
      return;
    }

    let selectedPermissions = [...(formData.permissionNames ? formData.permissionNames : [])];

    if (checked) {
      selectedPermissions = [...selectedPermissions, permissionName.toString()];
    } else {
      selectedPermissions = selectedPermissions.filter((obj) => obj !== permissionName.toString());
    }

    onChange({ ...formData, permissionNames: selectedPermissions });
  };

  const permissionCategories = uniq(adminPermissions?.map((p) => p.category))
    .sort()
    .reverse();

  const permissionCategoryRender = (category: string | null, index: number) => {
    const lenght = adminPermissions?.filter((p) => p.category === category).length;
    const selected = adminPermissions?.filter(
      (p) => p.category === category && formData.permissionNames?.includes(p.name)
    ).length;
    return (
      <>
        <AccordionTitle
          active={accordionActiveIndex === index}
          index={index}
          onClick={() => setAccordionActiveIndex(index)}
          key={category}
        >
          <h5>
            <Icon name="dropdown" />
            {`${category} (${selected}/${lenght})`}
          </h5>
        </AccordionTitle>
        <AccordionContent active={accordionActiveIndex === index}>
          <Card.Group itemsPerRow={2} style={{ "margin-left": "15px" }}>
            {adminPermissions?.filter((p) => p.category === category).map((p) => permissionRender(p))}
          </Card.Group>
        </AccordionContent>
      </>
    );
  };

  const permissionRender = (permission: ApplicationPermission) => {
    return (
      <Card style={{ "box-shadow": "0px 0px", margin: "7px" }}>
        <Form.Field>
          <Checkbox
            label={permission.displayName}
            name={permission.name}
            value={permission.name}
            checked={formData.permissionNames?.includes(permission.name)}
            onChange={handlePermissionChange}
          />
        </Form.Field>
      </Card>
    );
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Name</label>
            <Form.Input
              error={formErrors.displayName}
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
            />
          </Form.Field>
        </Form.Group>

        <Header as="h5" dividing>
          Permissions
        </Header>
        <Accordion fluid style={{ minHeight: "270px" }}>
          {permissionCategories?.map((c, index) => permissionCategoryRender(c, index))}
        </Accordion>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default EditAdminRoleForm;
